<template>
    <v-container fluid class="d-flex pa-0 fullHeight">
        <v-container fluid class="scrollableContent pa-0">
            <v-container class="container-custom px-6">
                <Breadcrumbs :title="'Listado de Alumno Materias'" :description="'gestion de estado de alumno materias'">
                </Breadcrumbs>
                <v-row justify="center">
                    <v-col sm="12" class="viewSpaces">
                        <SuperTable :headers="headers" :data="subjects" @searchAction="searchAction"
                        @setStatusOngoing="setStatusOngoing"  @setStatusApproved="setStatusApproved"
                        @setStatusReproved="setStatusReproved"  @setStatusCanceled="setStatusCanceled"
                        @approveSelected="approveSelected" @reproveSelected="reproveSelected"
                        @setStatusPending="setStatusPending" @setFinalNote="setFinalNote"
                        :server-side="true" :total-items="totalItems" @update:options="onOptionsChange"
                        ></SuperTable>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
            <div class="popup-container" v-if="newGradeValue" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.5);display: flex;justify-content: center;align-items: center;z-index: 9999;">
            <div class="popup-content" style="padding: 20px;border-radius: 10px;max-width: 80%;overflow: auto;">
            <v-container fluid class="pa-0 pb-8">
              <v-container class="container-custom">
                <v-row justify="center">
                <v-col class="viewSpaces" sm="12">
                <OutlinedCard :title="'Nota'" class="mb-6">
                <v-row>
                  <v-col sm="12" class="py-2">
                    <v-text-field
                      v-model="newGrade"
                      :label="'Nueva nota *'"
                      outlined
                      type="number"
                      @input="validateInputNewGrade"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div class="d-flex justify-end">
                  <v-btn class="ma-2" color="green" @click="updateGrade">
                        <v-icon color="white">mdi-check</v-icon>
                  </v-btn>
                  <v-btn class="ma-2" color="red" @click="$data.newGradeValue = false">
                    <v-icon color="white">mdi-cancel</v-icon>
                  </v-btn>
                  </div>
                </OutlinedCard>
            </v-col>
            </v-row>
            </v-container>
            </v-container>
            </div>
          </div>
    </v-container>
</template>

<script>
import SuperTable from '../Components/SuperTable/SuperTable';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
import { $studentSubjects } from '../Services';

export default {
    name: 'StudentSubjectsStatusTable',
    components: {
        SuperTable,
        Breadcrumbs,
        OutlinedCard
    },
    data() {
        return {
            search: '',
            newGradeValue: false,
            selectUpdate: null,
            newGrade: null,
            subjects: [
            ],
            totalItems: 0,
            options: {
                page: 1,
                itemsPerPage: 20
            },
            headers: [
                {
                    text: 'Legajo',
                    value: 'studentCareerId'
                }, {
                    text: 'Alumno',
                    value: 'fullName'
                }, {
                    text: 'Materia',
                    value: 'subjectDescription'
                }, {
                    text: 'Nota final',
                    value: 'grade'
                }, {
                    text: 'Código',
                    value: 'subjectCode',
                }, {
                    text: 'Tipo',
                    value: 'subjectType'
                }, {
                    text: 'Estado',
                    value: 'subjectStatus'
                }, {
                    text: 'Acciones',
                    value: 'action'
                }
            ],
        }
    },
    methods: {
    searchAction(data) {
            this.search = data;
            this.options.page = 1; // Reset to first page on new search
            this.getStudent();
        },

        onOptionsChange(options) {
            this.options.page = options.page;
            this.options.itemsPerPage = options.itemsPerPage;
            this.getStudent();
        },
        async getStudent() {
            try {
                // Backend uses 0-indexed page for Spring Data, Vue uses 1-indexed.
                const page = this.options.page > 0 ? this.options.page - 1 : 0;
                const student = await $studentSubjects.getStudentSubjets(this.search, page, this.options.itemsPerPage)
                this.subjects = []
                const data = student.data.content || [];
                this.totalItems = student.data.totalElements || 0;
                if (data.length) {
                    data.forEach(studentSubject => {
                        const grade = studentSubject.grade || 'Sin nota';
                        this.subjects.push({
                            studentStatusDetail: studentSubject.studentStatusDetail,
                            subjectDescription: studentSubject.subjectDescription,
                            subjectCode: studentSubject.subjectCode,
                            id: studentSubject.id,
                            status: studentSubject.status,
                            studentCareerId: studentSubject.studentCareerId,
                            subjectType: studentSubject.subjectType,
                            subjectStatus: studentSubject.subjectStatus,
                            subjectStatusCode: studentSubject.subjectStatusCode,
                            fullName: `${studentSubject.name} ${studentSubject.lastName}`,
                            grade
                        })
                    })
                }
            } catch (error) {
                this.subjects = [];
                this.totalItems = 0;
            }
        },
        async setStatusOngoing(item) {
            try {
                await $studentSubjects.setStatusOngoing(item.id)
                this.getStudent();
            } catch (error) {
                this.getStudent();
            }
        },
        async setStatusApproved(item) {
            try {
                await $studentSubjects.setStatusApproved(item.id)
                this.getStudent();
            } catch (error) {
                this.getStudent();
            }
        },
        async setStatusReproved(item) {
            try {
                await $studentSubjects.setStatusReproved(item.id)
                this.getStudent();
            } catch (error) {
                this.getStudent();
            }
        },
        async setStatusCanceled(item) {
            try {
                await $studentSubjects.setStatusCanceled(item.id)
                this.getStudent();
            } catch (error) {
                this.getStudent();
            }
        },
        async setStatusPending(item) {
            try {
                await $studentSubjects.setStatusPending(item.id)
                this.getStudent();
            } catch (error) {
                this.getStudent();
            }
        },
        async approveSelected(ids) {
            try {
                await $studentSubjects.setStatusApproved(ids)
                this.getStudent();
            } catch (error) {
                this.getStudent();
            }
        },        
        async reproveSelected(ids) {
            try {
                await $studentSubjects.setStatusReproved(ids)
                this.getStudent();
            } catch (error) {
                this.getStudent();
            }
        },
        async setFinalNote(item) {
            try {
                this.selectUpdate = item;
                this.newGradeValue = true;
            } catch(error) {
                this.getStudent();
            }
        },
       async updateGrade() {
         
        const updateGrade = {
        id: this.selectUpdate.id,
        studentCareerId: this.selectUpdate.studentCareerId,
        grade: this.newGrade,
        };

        try {
          await $studentSubjects.updateStudentSubjectGrade(updateGrade, this.selectUpdate.id);
          this.getStudent();
          this.newGradeValue = false;
          this.$store.dispatch('commons/openPopUp', {
            title: 'Cambio de nota exitoso',
            actionPrimary: {
              text: 'Aceptar',
              callback() {},
            },
            icon: { color: 'success', name: 'mdi-check' },
            color: 'primary',
          });
        } catch {
          this.newGradeValue = false;
          this.$store.dispatch('commons/openPopUp', {
            title: 'Error en el cambio de nota',
            actionPrimary: {
              text: 'Aceptar',
              callback() {},
            },
            icon: { color: 'error', name: 'mdi-alert' },
            color: 'primary',
          });
        }},
        validateInputNewGrade() {
        this.newGrade = this.newGrade.replace(/[^0-9.]/g, '');
        const num = parseFloat(this.newGrade);
        if (isNaN(num) || num < 0 || num > 10) {
          this.newGrade = '';
        }}
},
}
</script>
